export * from './patient-consultation.model';
export * from './patient-consultation.service';
export * from './patient-consultation.module';
